import { ArrowLongRightIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import cx from "classix";

const buttonVariants = {
  primary: { buttonClass: "btn-primary hover:text-white", arrowColor: "white" },
  secondary: { buttonClass: "btn-secondary", arrowColor: "white" },
  "outline-primary": {
    buttonClass: "btn-outline-primary hover:text-black",
    arrowColor: "black",
  },
};

type Props = {
  text: string;
  href: string;
  variant?: keyof typeof buttonVariants;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default function ArrowedButtonLink({
  text,
  className,
  href,
  variant = "primary",
  ...rest
}: Props) {
  const buttonVariant = buttonVariants[variant];
  return (
    <Link
      href={href}
      {...rest}
      className={cx(buttonVariant.buttonClass, className, "block")}
    >
      <div className="flex items-center h-full">
        <ArrowLongRightIcon
          className={"mr-2 h-5 w-5"}
          color={buttonVariant.arrowColor}
        />
        <span>{text}</span>
      </div>
    </Link>
  );
}
